<template>
  <div class="beian">
    <div class="maozi-box">
      <img src="../assets/beian.png" class="maoziIcon" />
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=11010602201816"
        rel="noreferrer"
        target="_blank"
        class="maozia"
        >京公网安备11010602201816号</a
      >
    </div>
    <a class="ipcbeian" href="https://beian.miit.gov.cn/" target="_blank">京ICP备2025141382号-1</a>
  </div>
</template>
<script>
export default {
  name: 'BeiAnCom',
};
</script>

<style scoped>
.beian {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 600px;
  height: 30px;
  line-height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.maozi-box {
  margin-right: 10px;
  display: inline-block;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.maoziIcon {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.maozia {
  color: #fff;
  text-decoration: none;
}
.maozia:hover {
  color: #1366ec;
}
.ipcbeian {
  color: #fff;
  text-decoration: none;
}
.ipcbeian:hover {
  color: #1366ec;
}
</style>
